import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Sanatanbhavan';
const SITE_DESC =
  'Sanatanbhavan — Buy authentic Puja Samagri online: diyas, kalash, idols, rudraksha malas, hawan kund, festival puja kits & more. Free shipping above ₹500. Pan-India delivery.';
const DEFAULT_OG = 'https://images.unsplash.com/photo-1636080810842-2dc5cdfd9483?w=1200';

/**
 * Reusable SEO/<head> wrapper. Pass per-page overrides.
 * Pass `jsonLd` (a JS object) to inject schema.org structured data.
 */
export const SEO = ({
  title,
  description = SITE_DESC,
  image = DEFAULT_OG,
  url,
  type = 'website',
  jsonLd,
  keywords,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Authentic Puja Samagri Online Store`;
  const canonical = url || (typeof window !== 'undefined' ? window.location.href : undefined);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {canonical && <meta property="og:url" content={canonical} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

/** Site-wide Organization + WebSite JSON-LD — emit once at app root. */
export const OrganizationSchema = ({ siteUrl = 'https://sanatanbhavan.com' }) => {
  const data = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      url: siteUrl,
      logo: `${siteUrl}/favicon.ico`,
      sameAs: [],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+91-9831072381',
        contactType: 'customer service',
        areaServed: 'IN',
        availableLanguage: ['English', 'Hindi', 'Bengali'],
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '433/1, Sarat Ch Chatterjee Road',
        addressLocality: 'Howrah',
        postalCode: '711103',
        addressRegion: 'West Bengal',
        addressCountry: 'IN',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url: siteUrl,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/products?search={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
  ];
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};
